import React, {useState} from "react"
import {Slider} from "@mui/material";
import {t} from "i18next";
import {translationKeys} from "../../../localizations/translationKeys-localization";
import MaterialTextField from "../../../shared/components/MaterialTextField";
import {LABEL_TYPES} from "../../../shared/utils/constants";
import {useDispatch, useSelector} from "react-redux";
import useLinearScaleMgr from "../../hooks/useLinearScaleMgr";
import {APP_ACTION_TYPE} from "../../reducers/appReducer";
import MaterialTextFieldOutlined from "../../../shared/components/MaterialTextFieldOutlined";
import TextQuestionBody from "./TextQuestionBody";

const SliderBody = (props) => {

    const formData = useSelector(state => state.appReducer.formData)
    const question = useSelector(state => state.appReducer.formData.pages?.[0]?.questions?.[props.index])
    const [minValue, setMinValue] = useState(question?.slider_minimum_value ? question.slider_minimum_value : 0)
    const [maxValue, setMaxValue] = useState(question?.slider_maximum_value ? question.slider_maximum_value : 100)
    const [stepValue, setStepValue] = useState(question?.slider_steps_value ? question.slider_steps_value : 1)
    const [showError, setShowError] = useState(false)
    const [showStepError, setShowStepError] = useState(false)
    const {updateLabel} = useLinearScaleMgr()
    const dispatch = useDispatch()

    const handleMinValueChange = (value) => {
        setMinValue(parseInt(value))
        if (parseInt(value) >= parseInt(maxValue) || parseInt(value) > 10000 || parseInt(value) < -10000 || (maxValue - parseInt(value)) < stepValue) {
            setShowError(true)
        } else {
            const updatedFormData = {...formData}
            updatedFormData.pages[0].questions[props.index].slider_minimum_value = parseInt(value ? value : 0)
            dispatch({type: APP_ACTION_TYPE.SET_FORM_DATA, payload: updatedFormData})
            setShowError(false)
        }
    }

    const handleMaxValueChange = (value) => {
        setMaxValue(parseInt(value))
        if (parseInt(value) > 10000 || parseInt(value) < -10000 || (parseInt(value) - minValue) < stepValue) {
            setShowError(true)
        } else {
            const updatedFormData = {...formData}
            updatedFormData.pages[0].questions[props.index].slider_maximum_value = parseInt(value ? value : 100)
            dispatch({type: APP_ACTION_TYPE.SET_FORM_DATA, payload: updatedFormData})
            setShowError(false)
        }
    }

    const handleStepValueChange = (value) => {
        setStepValue(parseInt(value))
        if (parseInt(value) > Math.abs(maxValue - minValue) || parseInt(value) <= 0) {
            setShowStepError(true)
        } else {
            const updatedFormData = {...formData}
            updatedFormData.pages[0].questions[props.index].slider_steps_value = parseInt(value ? value : 1)
            dispatch({type: APP_ACTION_TYPE.SET_FORM_DATA, payload: updatedFormData})
            setShowStepError(false)
        }
    }

    return (
        <>
            <div style={{margin: "0 20px"}}>
                <Slider value={30}
                        disabled={true}
                        sx={{
                            color: '#212121',
                            '& .MuiSlider-track': {
                                border: 'none',
                            },
                            '& .MuiSlider-thumb': {
                                width: '20px',
                                height: '20px',
                                backgroundColor: "#FFFFFF",
                                border: `2px solid #E0E0E0`,
                            }
                        }}/>
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <div style={{textAlign: "start", display: "flex", flexDirection: "column"}}>
                        <MaterialTextFieldOutlined
                            placeHolder={t(translationKeys.min)}
                            defaultValue={minValue}
                            onBlur={() => {
                                setShowError(false)
                                setMinValue(props.question.slider_minimum_value)
                            }}
                            inputType={"number"}
                            onChange={handleMinValueChange}
                            textStyleObject={{textAlign: 'center'}}
                            customStyleObject={{
                                '--mdc-theme-primary': '#9e9e9e',
                                height: "40px",
                                width: "100px"
                            }}
                        />
                        {showError ? <span style={{color: "red"}}>
                            {minValue > 10000 || minValue < -10000 || maxValue > 10000 || maxValue < -10000 ? t(translationKeys.scale_range_error) : (minValue > maxValue) ? t(translationKeys.max_min_error) : t(translationKeys.scale_range_error2)}
                    </span> : null}
                    </div>
                    <div>
                        <MaterialTextFieldOutlined
                            placeHolder={t(translationKeys.max)}
                            defaultValue={maxValue}
                            onBlur={() => {
                                setShowError(false)
                                setMaxValue(props.question.slider_maximum_value)
                            }}
                            inputType={"number"}
                            onChange={handleMaxValueChange}
                            textStyleObject={{textAlign: 'center'}}
                            customStyleObject={{
                                '--mdc-theme-primary': '#9e9e9e',
                                height: "40px",
                                width: "100px"
                            }}
                        />
                    </div>
                </div>
                <div style={{textAlign: "start", margin: "20px 0", display: "flex", flexDirection: "column"}}>
                    <MaterialTextFieldOutlined
                        placeHolder={t(translationKeys.step_value)}
                        defaultValue={stepValue}
                        onBlur={() => {
                            setShowStepError(false)
                            setStepValue(props.question.slider_steps_value)
                        }}
                        inputType={"number"}
                        onChange={handleStepValueChange}
                        textStyleObject={{textAlign: 'center'}}
                        customStyleObject={{
                            '--mdc-theme-primary': '#9e9e9e',
                            height: "40px",
                            width: "100px"
                        }}
                    />
                    {showStepError ? <span style={{color: "red"}}>
                    {t(translationKeys.step_error) + " " + minValue + " " + t(translationKeys.and) + " " + maxValue}
                </span> : null}
                </div>
                <div style={{display: "flex", marginTop: "15px"}}>
                    <div className='sh-text-field' style={{marginRight: "25px"}}>
                        <MaterialTextField
                            id={`linear-scale-question-label-1`}
                            data={{
                                defaultValue: question?.start_label
                            }}
                            customStyleObject={{fontSize: "18px"}}
                            placeholder={t(translationKeys.left_label_optional)}
                            onChange={value => updateLabel(props.index, LABEL_TYPES.START, value)}
                            maxLength={100}
                            noLabel={true}
                            hideHelpLine={true}
                            forceUpdateRefVarFocus={false}
                            setForceUpdateRefVarFocus={null}
                        />
                    </div>
                    <div className='sh-text-field' style={{marginRight: "25px"}}>
                        <MaterialTextField
                            id={`linear-scale-question-label-2`}
                            data={{
                                defaultValue: question?.center_label
                            }}
                            customStyleObject={{fontSize: "18px"}}
                            placeholder={t(translationKeys.center_label_optional)}
                            onChange={value => updateLabel(props.index, LABEL_TYPES.CENTER, value)}
                            maxLength={100}
                            noLabel={true}
                            hideHelpLine={true}
                            forceUpdateRefVarFocus={false}
                            setForceUpdateRefVarFocus={null}
                        />
                    </div>
                    <div className='sh-text-field'>
                        <MaterialTextField
                            id={`linear-scale-question-label-3`}
                            data={{
                                defaultValue: question?.end_label
                            }}
                            customStyleObject={{fontSize: "18px"}}
                            placeholder={t(translationKeys.right_label_optional)}
                            onChange={value => updateLabel(props.index, LABEL_TYPES.END, value)}
                            maxLength={100}
                            noLabel={true}
                            hideHelpLine={true}
                            forceUpdateRefVarFocus={false}
                            setForceUpdateRefVarFocus={null}
                        />
                    </div>
                </div>
            </div>
            <div style={{paddingTop: "8px"}}>
                <TextQuestionBody {...props}/>
            </div>
        </>
    )
}

export default SliderBody
